import { render, staticRenderFns } from "./solicitacaoDesligamento.vue?vue&type=template&id=1d7ff8b6"
import script from "./solicitacaoDesligamento.vue?vue&type=script&lang=js"
export * from "./solicitacaoDesligamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports